import React, { useState, memo, useEffect } from "react";
import { Row ,Col,Card,Button} from 'react-bootstrap';

import FullMockDetails from "components/FullTest/MockOperations/FullMockDetails";
import MockTest from "components/FullTest/MockOperations/MockTest";
import TestFinished from "components/FullTest/MockOperations/TestFinished";
import { set } from "react-ga";
import FullScreen from "assets/images/FullScreen.png";
import DarkMode from "assets/images/DarkMode.png";
import ExitFullScreen from "assets/images/ExitFullScreen.png";
import LightMode from "assets/images/LightMode.png";
import { toggleFullScreen, toggleTheme, isFullScreen, isDarkMode } from "util/helper";

const TEST_FINISHED = 3;
const Mock = memo(function Mock({
  setStep,
  params,
  mockData,
  defaultCheckPoint,
}) {
  console.log(mockData, "mockData in mock.jsx");
  console.log(setStep, "setStep in mock.jsx");
  console.log(params, "params in mock.jsx");
  console.log(defaultCheckPoint, "defaultCheckPoint in mock.jsx");
  const [checkPoint, setCheckPoint] = useState(defaultCheckPoint);
  const [nextFlag, setNextFlag] = useState(false);

  const nextButton = (e) => {
    setCheckPoint((prev) => prev + 1);
    setNextFlag(false);
  };

  const startFullMockSection = () => {
    let section = 1;
    const skip = parseInt(mockData.skip);

    if (parseInt(params.pending)) {
      if (skip < 2) {
        section = skip + 1;
      } else if (skip === 2) {
        section = 4;
      } else {
        section = 0;
      }
    }
    return section;
  };

  return (
    <>
      {checkPoint === 1 && (
        <div className="content questionsArea deviceTestPage old-design p-0 test_width mock-container" id="test-card">
          <Row>
            <Col xs={12}>
              {/* TestHeader - Same as SectionalTest */}
              <Row className="m-0 test_width">
                <Row
                  className="d-flex justify-content-between align-items-center w-100 h-50 mock-header-bg"
                  style={{
                    // backgroundColor: "#BFBABB",
                    height: "40px	!important",
                  }}
                >
                  <Col
                    style={{
                      width: "fit-content",
                      padding: "0",
                    }}
                  >
                    <Card.Title tag="h4" className="m-0 mx-2">
                      Language Academy - Full Mock Test
                    </Card.Title>
                  </Col>
                </Row>
                <Row
                  style={{
                    backgroundColor: "#0081A4",
                    minHeight: "40px",
                  }}
                  className="d-flex justify-content-end align-items-center px-4"
                >
                  <div className="d-flex justify-content-end gap-3">
                    {/* <i className="fa fa-expand text-white" style={{ cursor: "pointer" }}></i>
                    <i className="fa fa-moon-o text-white" style={{ cursor: "pointer" }}></i> */}
                    <img
                      src={isFullScreen() ? ExitFullScreen : FullScreen}
                      onClick={() => {
                      toggleFullScreen();
                      setTimeout(() => {
                        forceUpdate({});
                      }, 100);
                      }}
                      alt={isFullScreen() ? "Exit Full Screen" : "Full Screen"}
                      className="toggle-icons"
                    />
                    <img
                      src={isDarkMode() ? LightMode : DarkMode}
                      onClick={() => {
                        toggleTheme();
                        forceUpdate({});
                      }}
                      alt={isDarkMode() ? "Light Mode" : "Dark Mode"}
                      className="toggle-icons"
                    />
                  </div>
                </Row>
              </Row>

              {/* Content with proper padding */}
              <div style={{ padding: "20px 40px 40px", paddingBottom: "80px" }}>
                <FullMockDetails
                  setCheckPoint={setCheckPoint}
                  mock={mockData}
                  setNextFlag={setNextFlag}
                />
              </div>
            </Col>

            {/* BottomBtns - Same as SectionalTest */}
            <Col xs={12}>
              <div className="bottomBtns fixed-bottom-row mock-header-gap">
                <Row className="align-items-center mx-0 gap-1 fixed-bottom-row w-100 mock-header-gap">
                  {/* <Col xs={2} className="d-flex justify-content-center align-items-center py-1 bottom-btn-toggle" style={{ minHeight: "50px", width: "20%" }}></Col> */}
                  <Col className="text-center py-2 z-3 mock-bottom-btn-toggle flex-grow-1" style={{ minHeight: "50px" }}></Col>
                  <Col xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "20%",minHeight: "50px" }}>
                    <Button
                      variant="primary"
                      disabled={!nextFlag}
                      onClick={nextButton}
                      size="xs"
                      className="mock-btn bottomBtnFont d-flex align-items-center"
                    >
                      NEXT
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      )}

      {checkPoint === 2 && (
        <MockTest
          setCheckPoint={setCheckPoint}
          mock={mockData}
          pending={parseInt(params.pending)}
          startSection={startFullMockSection()}
        />
      )}

      {checkPoint === TEST_FINISHED && <TestFinished />}
    </>
  );
});

export default Mock;
